import { NativeDateAdapter, MatDateFormats, MAT_DATE_FORMATS } from '@angular/material/core';
import { Injectable, Directive } from '@angular/core';

interface IDisplayFormatObject {
  day?: string;
  year?: string;
  month?: string;
}

@Injectable()
export class AppDateAdapter extends NativeDateAdapter {
  format(date: Date, displayFormat: IDisplayFormatObject | string): string {
    if (displayFormat === 'input') {
      const day = date.getDate().toString().padStart(2, '0');
      const month: string = (date.getMonth() + 1).toString().padStart(2, '0');
      const year = date.getFullYear();
      return `${month}/${day}/${year}`;
    } else if (displayFormat === 'selectedMonth') {
      const month: string = date.toLocaleString('default', { month: 'long' });
      const year = date.getFullYear();

      return `${month} ${year}`;
    }
    return date.toDateString();
  }
}
export const APP_DATE_FORMATS: MatDateFormats = {
  parse: {
    dateInput: { month: 'short', year: 'numeric', day: 'numeric' }
  },
  display: {
    dateInput: 'input',
    monthYearLabel: { year: 'numeric', month: 'numeric' },
    dateA11yLabel: { year: 'numeric', month: 'long', day: 'numeric' },
    monthYearA11yLabel: { year: 'numeric', month: 'long' }
  }
};

export const APP_DATE_SELECTED_MONTH: MatDateFormats = {
  parse: {
    dateInput: { month: 'long', year: 'numeric' }
  },
  display: {
    dateInput: 'selectedMonth',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY'
  }
};

@Directive({
  selector: '[appDateFormat]',
  providers: [{ provide: MAT_DATE_FORMATS, useValue: APP_DATE_FORMATS }]
})
export class AppDateFormatDirective {}

@Directive({
  selector: '[appDateSelectedMonth]',
  providers: [{ provide: MAT_DATE_FORMATS, useValue: APP_DATE_SELECTED_MONTH }]
})
export class AppDateSelectedMonthDirective {}
